var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgTargetIconCategory = function SvgTargetIconCategory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.142 6.415L11 9.273l2.858-2.858M11 1.313v7.302",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.343,
    y: 20.523,
    width: 18.686,
    height: 9.762,
    rx: 4,
    transform: "rotate(-180 20.343 20.523)"
  }))));
};
export default SvgTargetIconCategory;